<template>
  <div class="content_wall">
    <div class="wrapper clearfix">
      <div class="main">
        <div class="archive_head">
          <h2>
            <span class="accept_space"></span>
            2020年(令和２)
          </h2>
        </div>
        <div class="calendar_head ">
          <h1>運営体制</h1>
        </div>
        <div class="plan ">
          <ul>
            <li><a href="https://drive.google.com/file/d/1rPueT7AhPhAvicePXAIltsTW4FRV6d3B/view?usp=sharing" target="_blank">成蹊大学体育会柔道部活動計画書</a></li>
          </ul>
        </div>
        <div class="calendar_head ">
          <h1>
            スケジュールカレンダー
          </h1>
        </div>
        <div class="month_photo_2 ">
          <a href="https://drive.google.com/file/d/1foNh2F29IM_St1vmlXTDjLa5Xwm0nuju/view?usp=sharing" target="_blank"><img src="https://3.bp.blogspot.com/-qiEFidRnPMk/U8XkvNrFT9I/AAAAAAAAi3I/57gfMd3GrFQ/s300/tsuki_title01.png" width="170"></a>
          <a href="https://drive.google.com/file/d/1OoZ0e-CZxwxGHs9Aos4pzdQFhEZlQw6j/view?usp=sharing" target="_blank"><img src="https://1.bp.blogspot.com/-dTmHITKHw6s/U8XkvSYml8I/AAAAAAAAi3Q/kM0rjYAHiUw/s300/tsuki_title02.png" width="170"></a>
          <a href="https://drive.google.com/file/d/1IVgsB-KXInYLHY145nf2S7QMldMUtMYu/view?usp=sharing" target="_blank"><img src="https://4.bp.blogspot.com/-WsMGh5LpZN0/U8XkvkNQZqI/AAAAAAAAi3U/Eg9DY3Az4_s/s300/tsuki_title03.png" width="170"></a>
          <a href="https://drive.google.com/file/d/1FUn1QioddD2k6nRwV91tvmlVFIf1_J9D/view?usp=sharing" target="_blank"><img src="https://1.bp.blogspot.com/-u6QSJJIQCZM/U8XkwJvPXmI/AAAAAAAAi3c/-g1D77EKGKc/s300/tsuki_title04.png" width="170"></a>
          <a href="https://drive.google.com/file/d/1ZCpTed1nbBry9yKa1WGNgyIO2EbyLwn3/view?usp=sharing" target="_blank"><img src="https://2.bp.blogspot.com/-2A4dDGGKkIk/U8XkwTo5kkI/AAAAAAAAi3k/zjV3nf9O8zE/s300/tsuki_title05.png" width="170"></a>
          <a href="https://drive.google.com/file/d/1ly5GyG3cpVJ5pYWRlAPI_emu0SZ-SYZY/view?usp=sharing" target="_blank"><img src="https://3.bp.blogspot.com/-v_RtDt-S6g8/U8XkwpSQiSI/AAAAAAAAi3s/ZI9rb1F2DgY/s300/tsuki_title06.png" width="170"></a>
          <a href="https://drive.google.com/file/d/1LsmJF7IYL26Ctogd0Y75PNWDOf80u5w-/view?usp=sharing" target="_blank"><img src="https://1.bp.blogspot.com/-dmF08LX4j_g/U8XkxIG_DZI/AAAAAAAAi3w/f5BgsGBSuJ0/s300/tsuki_title07.png" width="170"></a>
          <a href="https://drive.google.com/file/d/12InNGQZgUwToVqCIMvRejWVnfgcaHgwL/view?usp=sharing" target="_blank"><img src="https://2.bp.blogspot.com/-SL05y-_psJc/U8XkxXNcciI/AAAAAAAAi34/_edJyZzihdM/s300/tsuki_title08.png" width="170"></a>
          <a href="https://drive.google.com/file/d/1OKtpGmFPUr5UNCm0BM2gglVgDkCIL5Rm/view?usp=sharing" target="_blank"><img src="https://4.bp.blogspot.com/-I0wQNl0kuNw/U8XkxvipODI/AAAAAAAAi4I/BnRcPjSKA1w/s300/tsuki_title09.png" width="170"></a>
          <a href="https://drive.google.com/file/d/1tjZ4cRzz28LpD-qAdWDvRKzVrA54EOGV/view?usp=sharing" target="_blank"><img src="https://2.bp.blogspot.com/-bsU7PQpPjEU/U8Xkx10jejI/AAAAAAAAi4E/BAfM-wOxnIg/s300/tsuki_title10.png" width="170"></a>
          <a href="https://drive.google.com/file/d/18G20ingubtwPe7wMk_uzXbGbaR7gflTW/view?usp=sharing" target="_blank"><img src="https://2.bp.blogspot.com/-tDSpOOsm4Eo/U8XkyBchALI/AAAAAAAAi4M/YiawtwsFzfM/s300/tsuki_title11.png" width="170"></a>
          <a href="https://drive.google.com/file/d/1tXb7EiZS4Yj3sovu29fNp4OVBal7erpK/view?usp=sharing" target="_blank"><img src="https://1.bp.blogspot.com/-8PFUVpeNfMI/U8Xky953b9I/AAAAAAAAi4Y/IebnDQBC5ck/s300/tsuki_title12.png" width="170"></a>
        </div>
        <div class="calendar_head ">
          <h1>大会成績</h1>
        </div>
        <div>
          <div class="match_box ">
            <div class="ribbon13-wrapper">
              <div class="ribbon13">
                <h3>東京学生柔道優勝大会</h3>
              </div>
              <p class="no1"><br><br>
                2020年<br>
                COVID-19の影響により不参加<br><br>
              </p>
            </div>
            <div class="ribbon13-wrapper">
              <div class="ribbon13">
                <h3>東京四大学新人戦</h3>
              </div>
              <p class="no1"><br><br>
                2020年<br>
                COVID-19の影響により中止<br><br>
              </p>
            </div>
          </div>
          <div class="match_box ">
            <div class="ribbon13-wrapper">
              <div class="ribbon13">
                <h3>東京学生柔道体重別選手権大会</h3>
              </div>
              <p class="no1"><br><br>
                2020年<br>
                COVID-19の影響により不参加<br><br>
              </p>
            </div>
            <div class="ribbon13-wrapper">
              <div class="ribbon13">
                <h3>東京四大学本戦</h3>
              </div>
              <p class="no1"><br><br>
                2020年<br>
                COVID-19の影響により中止<br><br>
              </p>
            </div>
          </div>
          <div class="match_box ">
            <div class="ribbon13-wrapper">
              <div class="ribbon13">
                <h3>
                  <span class="accept_space"></span>
                  杉並区民体育祭柔道の部
                </h3>
              </div>
              <p class="no1"><br><br>
                2020年<br>
                COVID-19の影響により中止<br><br>
              </p>
            </div>
            <div class="ribbon13-wrapper">
              <div class="ribbon13">
                <h3>東京学生柔道二部優勝大会</h3>
              </div>
              <p class="no1"><br><br>
                2020年<br>
                COVID-19の影響により中止<br><br>
              </p>
            </div>
          </div>
          <div class="match_box ">
            <div class="ribbon13-wrapper">
              <div class="ribbon13">
                <h3>東京学生柔道オープン大会</h3>
              </div>
              <p class="no1"><br><br>
                2020年<br>
                COVID-19の影響により中止<br><br>
              </p>
            </div>
            <div class="ribbon13-wrapper">
              <div class="ribbon13">
                <h3>全日本理工科学生柔道優勝大会</h3>
              </div>
              <p class="no1"><br><br>
                2020年<br>
                COVID-19の影響により中止<br><br>
              </p>
            </div>
          </div>
        </div>
        <div class="calendar_head ">
          <h1>制作動画</h1>
        </div>
        <div class="match_box ">
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://twitter.com/seikeijudo/status/1243585314699894784">新歓動画 ver.1</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://twitter.com/seikeijudo/status/1252506536833740802">トレーニング動画１</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://twitter.com/seikeijudo/status/1252507401657421824">トレーニング動画２</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://twitter.com/seikeijudo/status/1252508019943813120">トレーニング動画３</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://twitter.com/seikeijudo/status/1252508590633439232">トレーニング動画４</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://twitter.com/seikeijudo/status/1252508590633439232">自粛中のトレーニング動画</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://twitter.com/seikei0judo/status/1258014072143966209">新歓動画 ver.2</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://twitter.com/seikei0judo/status/1263393795715915781">新歓動画 ver3</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://twitter.com/seikei0judo/status/1265275321588125701">新歓動画 ver4</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://www.youtube.com/watch?v=jJ3h1OOYl_k&t=124s">成蹊大学あるある座談会１</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://www.youtube.com/watch?v=BoPvAnETw1o">成蹊大学あるある座談会２</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://www.youtube.com/watch?v=H74HiD-X6_s">成蹊大学あるある座談会３</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://www.youtube.com/watch?v=rbfE6yK_6go">成蹊大学あるある座談会４</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://www.youtube.com/watch?v=7rJuZ6-fFxE">成蹊大学あるある座談会５</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://www.youtube.com/watch?v=wog8zudwbXY">成蹊大学あるある座談会６</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://www.youtube.com/watch?v=AkhGEslZq_M">成蹊大学あるある座談会７</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://www.youtube.com/watch?v=6eb424hldcE">成蹊大学あるある座談会８</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://www.youtube.com/watch?v=YCm7rIR3z6Y">成蹊大学あるある座談会９</a></p>
          </div>
          <div class="ribbon20-wrapper">
            <h3 class="ribbon20">動画</h3>
            <p><a href="https://www.youtube.com/watch?v=DTf8V-WE-7g">成蹊大学あるある座談会１０</a></p>
          </div>
        </div>
        <div class="calendar_head">
          <h1>デイリートピックス</h1>
        </div>
        <section class="news">
          <ul class="scroll-list archive_scroll-list">
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1327578509238157312">
                <time class="date">2020.11.14 SAT</time>
                <span class="category">
                  <span class="accept_space"></span>
                  練
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  習
                  <span class="accept_space"></span>
                </span>
                <span class="title">できることを少しずつしています</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1324971976050372610">
                <time class="date">2020.11.07 SAT</time>
                <span class="category">
                  <span class="accept_space"></span>
                  練
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  習
                  <span class="accept_space"></span>
                </span>
                <span class="title">成蹊大学柔道部通信【vol.4】</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://drive.google.com/file/d/18G20ingubtwPe7wMk_uzXbGbaR7gflTW/view?usp=sharing">
                <time class="date">2020.11.03 TUE</time>
                <span class="category">
                  <span class="accept_space"></span>
                  11月予定
                  <span class="accept_space"></span>
                </span>
                <span class="title">成蹊大学柔道部通信【vol.3】</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1319266454726832131">
                <time class="date">2020.10.22 THU</time>
                <span class="category">
                  <span class="accept_space"></span>
                  練
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  習
                  <span class="accept_space"></span>
                </span>
                <span class="title">成蹊大学柔道部通信【vol.2】</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1319266454726832131" target="_blank">
                <time class="date">2020.10.13 TUE</time>
                <span class="category">
                  <span class="accept_space"></span>
                  再
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  開
                  <span class="accept_space"></span>
                </span>
                <span class="title">成蹊大学柔道部通信【vol.1】</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1312064057042665474">
                <time class="date">2020.10.02 FRI</time>
                <span class="category">
                  <span class="accept_space"></span>
                  誕
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  生
                  <span class="accept_space"></span>
                </span>
                <span class="title">成蹊大学柔道部の公式マスコットです！</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://drive.google.com/file/d/1jelW5qAPGqT8rj2OzsxGBPy7ggavekuh/view?usp=sharing">
                <time class="date">2020.04.12 SUN</time>
                <span class="category">
                  <span class="accept_space"></span>
                  中
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  止
                  <span class="accept_space"></span>
                </span>
                <span class="title">この度は、東京都が発令した緊急事態宣言により開催を中止にせざるを得なくなりましたby成蹊大学柔道部</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1268389663456112640">
                <time class="date">2020.06.04 THU</time>
                <span class="category">
                  <span class="accept_space"></span>
                  動
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  画
                  <span class="accept_space"></span>
                </span>
                <span class="title">成蹊大学あるある動画をYouTubeにて公開しました！</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1264475837174145025">
                <time class="date">2020.05.24 SUN</time>
                <span class="category">
                  <span class="accept_space"></span>
                  動
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  画
                  <span class="accept_space"></span>
                </span>
                <span class="title">自粛中の個人トレーニングの様子を動画にしました！</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1252506536833740802">
                <time class="date">2020.04.21 TUE</time>
                <span class="category">
                  <span class="accept_space"></span>
                  動
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  画
                  <span class="accept_space"></span>
                </span>
                <span class="title">３年の伊藤が筋トレ動画を公開しました！</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1234335033894162433">
                <time class="date">2020.02.20 SAT</time>
                <span class="category">
                  <span class="accept_space"></span>
                  中
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  止
                  <span class="accept_space"></span>
                </span>
                <span class="title">お花見会中止のお知らせ</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1227576960882069504">
                <time class="date">2020.02.12 WED</time>
                <span class="category">
                  <span class="accept_space"></span>
                  稽
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  古
                  <span class="accept_space"></span>
                </span>
                <span class="title">立正高校に出稽古に行きました！</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1226835561840705537">
                <time class="date">2020.02.10 MON</time>
                <span class="category">
                  <span class="accept_space"></span>
                  練
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  習
                  <span class="accept_space"></span>
                </span>
                <span class="title">午後は先輩からの技術指導もあり充実した日となりました！by成蹊大学柔道部</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://seikei-university-judo-tg.netlify.app/coach_interview">
                <time class="date">2020.02.06 TUE</time>
                <span class="category">
                  <span class="accept_space"></span>
                  監督特集
                  <span class="accept_space"></span>
                </span>
                <span class="title">特集成蹊大学柔道部のOBであり、また何年にもわたり成蹊柔道部を指導してきた監督の柔道人生に迫る！！</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1224580805868974080">
                <time class="date">2020.02.04 TUE</time>
                <span class="category">
                  <span class="accept_space"></span>
                  練
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  習
                  <span class="accept_space"></span>
                </span>
                <span class="title">練習後に業務内容の引き継ぎを行いました</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1224264994461634561">
                <time class="date">2020.02.03 MON</time>
                <span class="category">
                  <span class="accept_space"></span>
                  筋力トレ
                  <span class="accept_space"></span>
                </span>
                <span class="title">テスト明け最初の練習！！</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1223455114741997568">
                <time class="date">2020.02.01 SAT</time>
                <span class="category">
                  <span class="accept_space"></span>
                  定例の会
                  <span class="accept_space"></span>
                </span>
                <span class="title">本日は、テスト明け初の活動！主に話し合いを行いました！！by成蹊大学柔道部</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1215766675527651331">
                <time class="date">2020.01.11 SAT</time>
                <span class="category">
                  <span class="accept_space"></span>
                  稽
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  古
                  <span class="accept_space"></span>
                </span>
                <span class="title">とりあえず、寒かったです</span>
              </a>
            </li>
            <li class="scroll-item ">
              <a href="https://twitter.com/seikeijudo/status/1215108058306596864">
                <time class="date">2020.01.09 THU</time>
                <span class="category">
                  <span class="accept_space"></span>
                  稽
                  <span class="accept_space"></span>
                  <span class="accept_space"></span>
                  古
                  <span class="accept_space"></span>
                </span>
                <span class="title">寒い畳と格闘しながら、寒稽古をいたしました！</span>
              </a>
            </li>
          </ul>
        </section>
      </div>
      <SIDEMENU></SIDEMENU>
    </div>
  </div>
</template>

<script>
import SIDEMENU from "./sidemenu.vue";
export default {
  components:{
    SIDEMENU
  }
};
</script>
